<template>
  <samp>{{ minuteVal }}</samp>
</template>

<script>
export default {
  props: {
    startTime: {
      type: String,
      default: String
    },
    endTime: {
      type: String,
      default: String
    },
    message: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      minuteVal: ''
    };
  },
  watch: {
    startTime() {
      window.clearInterval(this.timer);
      this.startTiming(1);
    },
    endTime() {
      window.clearInterval(this.timer);
      this.startTiming(1);
    }
  },
  created() {
    window.clearInterval(this.timer);
    this.startTiming(1);
  },
  methods: {
    startTiming(val) {
      const vm = this;
      const mss = vm.message == '预约将到' ? (new Date(vm.endTime).getTime() - new Date(vm.startTime).getTime()) : (new Date(vm.startTime).getTime() - new Date(vm.endTime).getTime() + 2000);
      let minute = Math.floor(mss / 1000 / 60);
      let second = Math.round((mss % (1000 * 60)) / 1000);
      if (val == 1) {
        if (vm.message == '预约将到') {
          vm.timer = setInterval(() => {
            if (second >= 0) {
              second += 1;
            }
            if (second >= 60) {
              second = 0;
              minute -= 1;
            }
            if (minute < 0) {
              vm.$emit('refresh', '预约已到');
            }
            vm.minuteVal = `${minute}分钟`;
          }, 1000);
        } else {
          vm.timer = setInterval(() => {
            if (second >= 0) {
              second += 1;
            }
            if (second >= 60) {
              second = 0;
              minute += 1;
            }
            if (minute > 999) {
              vm.minuteVal = '999分钟';
            } else {
              vm.minuteVal = `${minute}分钟`;
            }
          }, 1000);
        }
      } else {
        window.clearInterval(vm.timer);
      }
    }
  }
};
</script>
